import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";
import {Box, Center, Grid, GridItem, Spinner} from "@chakra-ui/react";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import PlacesAutocomplete from "react-places-autocomplete";
import { Heading, Image, Flex, Input, Select, Text } from "@chakra-ui/react";
import Map from "../img/map.png";
import GrayPin from "../img/pin_gray.png";
import Pin from "../img/pin_default.png";
import PropertyBox from "../components/PropertyBox";
import SearchMap from "../components/old-site/SearchMap2";
import {
  ListIcon,
  LocateIcon,
  LocatorIcon,
  MapIcon,
} from "../components/Icons";
import { propertyUrl } from "../components/Utils";
import useBestLocation from "../hooks/useBestLocation";

const commonSpaceCondition = {
  immediately: "turnkey",
  "30days": "turnkey,2nd generation",
  "3months": "turnkey,2nd generation,pre-existing",
  "6months": "turnkey,2nd generation,pre-existing,challenged",
  "9months": "turnkey,2nd generation,pre-existing,challenged,core and shell",
};

const SearchPage = () => {
  const mapRef = useRef(null);
  const [map, setMap] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchForState, setSearchForState] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const [searchCenter, setSearchCenter] = useState(null);
  const [existingAddress, setExistingAddress] = useState(null);
  const [isBound, setIsBound] = useState(false);
  const useSearchResultBounds = false; // If the map isn't visible, Jen wants to fall back to properties in your state, rather than using the Google Places bounding box from your City, State
  const [searchResultBounds, setSearchResultBounds] = useState();
  const [isAddressStarted, setIsAddressStarted] = useState("");
  const [fullProperties, setFullProperties] = useState([]);
  const [fullRelatedProperties, setFullRelatedProperties] = useState([]);
  const [relatedProperty, setRelatedProperty] = useState([]);
  const [compiledBound, setCompiledBound] = useState(null);

  const US_STATES = [
    { code: "AL", name: "Alabama", lat: 32.806671, lng: -86.79113 },
    { code: "AK", name: "Alaska", lat: 64.200841, lng: -149.493673 },
    { code: "AZ", name: "Arizona", lat: 33.729759, lng: -111.431221 },
    { code: "AR", name: "Arkansas", lat: 34.969704, lng: -92.373123 },
    { code: "CA", name: "California", lat: 36.116203, lng: -119.681564 },
    { code: "CO", name: "Colorado", lat: 39.059811, lng: -105.311104 },
    { code: "CT", name: "Connecticut", lat: 41.597782, lng: -72.755371 },
    { code: "DE", name: "Delaware", lat: 39.318515, lng: -75.507141 },
    { code: "FL", name: "Florida", lat: 27.766279, lng: -81.686783 },
    { code: "GA", name: "Georgia", lat: 33.040619, lng: -83.643074 },
    { code: "HI", name: "Hawaii", lat: 21.094318, lng: -157.498337 },
    { code: "ID", name: "Idaho", lat: 44.240459, lng: -114.478828 },
    { code: "IL", name: "Illinois", lat: 40.349457, lng: -88.986137 },
    { code: "IN", name: "Indiana", lat: 39.849426, lng: -86.258278 },
    { code: "IA", name: "Iowa", lat: 42.011539, lng: -93.210526 },
    { code: "KS", name: "Kansas", lat: 38.5266, lng: -96.726486 },
    { code: "KY", name: "Kentucky", lat: 37.66814, lng: -84.670067 },
    { code: "LA", name: "Louisiana", lat: 31.169546, lng: -91.867805 },
    { code: "ME", name: "Maine", lat: 44.693947, lng: -69.381927 },
    { code: "MD", name: "Maryland", lat: 39.063946, lng: -76.802101 },
    { code: "MA", name: "Massachusetts", lat: 42.230171, lng: -71.530106 },
    { code: "MI", name: "Michigan", lat: 43.326618, lng: -84.536095 },
    { code: "MN", name: "Minnesota", lat: 45.694454, lng: -93.900192 },
    { code: "MS", name: "Mississippi", lat: 32.741646, lng: -89.678696 },
    { code: "MO", name: "Missouri", lat: 38.456085, lng: -92.288368 },
    { code: "MT", name: "Montana", lat: 46.921925, lng: -110.454353 },
    { code: "NE", name: "Nebraska", lat: 41.12537, lng: -98.268082 },
    { code: "NV", name: "Nevada", lat: 38.313515, lng: -117.055374 },
    { code: "NH", name: "New Hampshire", lat: 43.452492, lng: -71.563896 },
    { code: "NJ", name: "New Jersey", lat: 40.298904, lng: -74.521011 },
    { code: "NM", name: "New Mexico", lat: 34.840515, lng: -106.248482 },
    { code: "NY", name: "New York", lat: 42.165726, lng: -74.948051 },
    { code: "NC", name: "North Carolina", lat: 35.630066, lng: -79.806419 },
    { code: "ND", name: "North Dakota", lat: 47.528912, lng: -99.784012 },
    { code: "OH", name: "Ohio", lat: 40.388783, lng: -82.764915 },
    { code: "OK", name: "Oklahoma", lat: 35.565342, lng: -96.928917 },
    { code: "OR", name: "Oregon", lat: 44.572021, lng: -122.070938 },
    { code: "PA", name: "Pennsylvania", lat: 40.590752, lng: -77.209755 },
    { code: "RI", name: "Rhode Island", lat: 41.680893, lng: -71.51178 },
    { code: "SC", name: "South Carolina", lat: 33.856892, lng: -80.94501 },
    { code: "SD", name: "South Dakota", lat: 44.299782, lng: -99.438828 },
    { code: "TN", name: "Tennessee", lat: 35.747845, lng: -86.692345 },
    { code: "TX", name: "Texas", lat: 31.054487, lng: -97.563461 },
    { code: "UT", name: "Utah", lat: 40.150032, lng: -111.862434 },
    { code: "VT", name: "Vermont", lat: 44.045876, lng: -72.710686 },
    { code: "VA", name: "Virginia", lat: 37.769337, lng: -78.169968 },
    { code: "WA", name: "Washington", lat: 47.400902, lng: -121.490494 },
    { code: "WV", name: "West Virginia", lat: 38.491226, lng: -80.95457 },
    { code: "WI", name: "Wisconsin", lat: 44.268543, lng: -89.616508 },
    { code: "WY", name: "Wyoming", lat: 42.755966, lng: -107.30249 },
  ];

  const history = useHistory();

  const distance = (latLong1, latLong2) => {
    let lat1, lng1, lat2, lng2;
    if (latLong1 instanceof window.google.maps.LatLng) {
      lat1 = latLong1.lat();
      lng1 = latLong1.lng();
    } else {
      lat1 = latLong1.lat;
      lng1 = latLong1.lng;
    }
    if (latLong2 instanceof window.google.maps.LatLng) {
      lat2 = latLong2.lat();
      lng2 = latLong2.lng();
    } else {
      lat2 = latLong2.lat;
      lng2 = latLong2.lng;
    }
    const toRadians = (deg) => (deg * Math.PI) / 180;

    const phi1 = toRadians(lat1);
    const phi2 = toRadians(lat2);
    const deltaphi = toRadians(lat2 - lat1);
    const deltalambda = toRadians(lng2 - lng1);

    const a =
      Math.sin(deltaphi / 2) * Math.sin(deltaphi / 2) +
      Math.cos(phi1) *
        Math.cos(phi2) *
        Math.sin(deltalambda / 2) *
        Math.sin(deltalambda / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const R = 3959; // Earth radius in miles
    return R * c;
  };

  const handleLocateIconClick = () => {
    // Attempt to get the user's current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const ll = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setSearchCenter(ll); // Update the center of the map
        },
        (error) => {
          console.error("Error fetching user location:", error);
        }
      );
    } else {
      console.warn("Geolocation is not supported by this browser.");
    }
  };

  const onMapMounted = (ref) => {
    mapRef.current = ref;

    //fitToSearchBounds();
  };

  const markerOnClick = (pro) => {
    window.location.href = propertyUrl(pro);
  };

  const onMapBoundsChanged = () => {
    console.log('onMapBoundsChanged')
    if (mapRef.current/* && intervalRun*/) {
      //setIntervalRun(false); // TODO - is there a better way to do this? Looks like we want to run this only once
      const bounds = mapRef.current.getBounds();
      console.log('current bounds', bounds)
      //let currentState = US_STATES.filter(state => bounds.contains(new window.google.maps.LatLng(state.lat, state.lng)));
      //setCompiledStates(currentState);
      setIsLoader(true);
      setCompiledBound(bounds);
    }

    if (mapRef.current && existingAddress !== address) {
      console.log("existingAddress", existingAddress);
      const actualBounds = mapRef.current.getBounds();

      setExistingAddress(address);
      //fitToSearchBounds();
      const actualCenter = mapRef.current.getCenter();
    }
  };

  //const fitToSearchBounds = () => {
  //  if (mapRef.current && drawBounds && !isSearchBound) {
  //    setIsSearchBound(true);
  //    mapRef.current.fitBounds(drawBounds);
  //  }
  //};

  const visitProperty = (property) => {
    window.location.href = propertyUrl(property);
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const address = searchParams.get("address")?.replace(", USA", "");
  const min = searchParams.get("min") === "null" ? "" : searchParams.get("min");
  const max = searchParams.get("max") === "null" ? "" : searchParams.get("max");
  const spaceCondition =
    searchParams.get("spaceCondition") === "null"
      ? ""
      : searchParams.get("spaceCondition");
  const availability =
    searchParams.get("availability") === "null"
      ? ""
      : searchParams.get("availability");
  const handleFormSubmit = useCallback((address) => {
    console.debug(`handleFormSubmit address=`, address)
    if(address.includes(',') && !address.endsWith(", USA") && !address.endsWith(", Canada")) {
      // We strip off ", USA" earlier, but some searches don't give the expected geocode result without it
      // e.g. "Niagara Falls, NY, USA" autocomplete is a place, but searching for "Niagara Falls, NY" reverse geocodes to the entire state
      console.debug(`Appending USA to ${address} before searching`)
      address = address + ", USA"
    }

    return geocodeByAddress(address)
      .then(async (results) => {
        console.debug(`handleFormSubmit geocodeByAddress results (only expecting first)`, results)
        // TODO - or try to handle things here to find the right result for "Niagara Falls, NY"
        const result = results[0]
        const latLng = await getLatLng(result)

        const stateObj = result.address_components.find((component) =>
          component.types.includes("administrative_area_level_1")
        );
        const state = stateObj ? stateObj.short_name : null;
        // Google maps says result.geometry.bounds is optional, so keep state as a last resort
        setSearchForState(state);

        setSearchResultBounds(result.geometry.bounds); // old site used this to set the map bounds, I think, instead of a fixed default zoom
        setSearchCenter(latLng);
        // history.push(`/search-page?address=${address}&min=${min}&max=${max}&availability=${availability}&spaceCondition=${spaceCondition}`);
        return latLng;
      })
      .catch((error) => console.error("Error", error));
  }, []);

  const [fetchedLatLng, setFetchedLatLng] = useState(null);

  //useEffect(() => {
  //  setIntervalRun(true);
  //  console.log("processLoaded", processLoaded);
  //}, [processLoaded]);


  const locationData = useBestLocation();

  useEffect(() => {

    if (address) {
      handleFormSubmit(address)
        .then((latLng) => {
          if (!isAddressStarted) {
            setFetchedLatLng(latLng);
            setIsBound(false);
            setIsAddressStarted(address);
          }
        })
        .catch((error) => console.error("Error", error));
    } else {
      // fall back to IP/Geo
      // TODO - can we just setAddress with this and setFetchedLatLong if we have it?
      if(locationData?.region) {
        console.log("kicking to IP/Geo location", `${locationData.city}, ${locationData.region}`)
        window.location.href =
            "/search?address=" + locationData.city + ", " + locationData.region;
      }
    }
  }, [address, handleFormSubmit, min, max, spaceCondition, availability, locationData?.city]);

  /* TODO - Can we simplify the data flow to get a location (name, center latlong, bounds/zoom) from:
       - submitted form
       - URL params
       - (future: city from a short city URL redirect)
       - geolocation (if browser supported)
       - IP location (does this need cookie confirmation?)

TODO - ideally don't run geo or IP if we're already searching
     - can we trick these hooks to not do any work even though we have to always add them in order


  Ideal dataflow:

  User types city into autocomplete
  this live text goes to GM Autocomplete
  API returns a list of Places
  user picks one
    - We should still have the Place
  current: we send the Place's formatted address to reverse geocode to a lat/long
      Sometimes this is weird or wrong, pick "Niagara Falls, NY, USA" and geocode
      returns "New York, USA" and "Niagara Falls, ON, CA", which are both wrong
  current hack: append ", USA" to the search and that appears to fix Niagara Falls
  future: the Place has the exact correct lat/long



  Other ways to get here:
  Short URL like /search/toledo-oh
    Swap hyphens back to ", ", maybe append ", USA"
      either send to autocomplete and pick first one, then reverse geocode that PlaceID
      or send this string to geocode, but that may still have the same Niagara Falls problem
  Search page before searching
    Browser location => lat/long => geocode to "city, state", then same flow as short URL?
    IP location => "city, state" , then same flow as short URL?
  No info at all falls back to full USA view? (Is it still doing that?)

   */



  useEffect(() => {
    if (isAddressStarted && isAddressStarted !== address) {
      console.debug(`354: kicking to ${address}`)
      window.location.href = "/search?address=" + address;
    }
  }, [address]);

  useEffect(() => {
    const checkBound = ({ state, maxSpaceSqft, lat, lng }) => {
      setIsLoader(true);
      let isCond = true;

      if (compiledBound) {
        isCond = compiledBound.contains(
          new window.google.maps.LatLng(lat, lng)
        );
      } else if (useSearchResultBounds && searchResultBounds) {
        isCond = searchResultBounds.contains(
            new window.google.maps.LatLng(lat, lng)
        );
      } else if (state && searchForState) {
        isCond = state === searchForState;
      }
      return isCond;
    };

    let filteredProperties = fullProperties;
    filteredProperties = fullProperties
      .filter((property) => checkBound(property))
      .sort((a, b) => distance(searchCenter, a) - distance(searchCenter, b));

    setSearchResults(filteredProperties);
  }, [compiledBound]); // TODO - searchForState should be in deps?

  useEffect(() => {
    if (fetchedLatLng) {
      setIsLoader(true);
      fetch("/available_ll.json", { mode: "cors" })
        .then((response) => response.json())
        .then(async (data) => {
          setFullProperties(Object.values(data));
          if (mapRef.current && searchCenter) {
            const bounds = await mapRef.current.getBounds();

            if (bounds) setIsBound(true);

            const checkState = ({ state, maxSpaceSqft, lat, lng }, bounds) => {
              let isCond = true;

              /*if(compiledStates)
              {
                let comstate = [];
                for(var ik=0; ik<compiledStates.length; ik++){

                  comstate.push(compiledStates[ik].code);
                }

                console.log("compiledStates",compiledStates);
                isCond = comstate.includes(state);
              }*/

              if (
                !compiledBound &&
                (address === "USA" || address === "United States")
              ) {
                isCond = true;
              } else if (compiledBound) {
                isCond = compiledBound.contains(
                  new window.google.maps.LatLng(lat, lng)
                );
              } else if (useSearchResultBounds && searchResultBounds) {
                isCond = searchResultBounds.contains(
                    new window.google.maps.LatLng(lat, lng)
                );
              } else if (state && searchForState) {
                isCond = state === searchForState;
              }

              return isCond;
            };

            const propertiesArray = Object.values(data);

            /* const filteredProperties = propertiesArray
               .filter((property) => bounds ? isLatLngInsideBounds(property, bounds) : false)
               .sort(
                 (a, b) => distance(searchCenter, a) - distance(searchCenter, b)
               );



            if ((address !== "USA") && (address !== "United States")) {
              filteredProperties = propertiesArray
                .filter((property) => checkState(property, bounds))
                .sort(
                  (a, b) => distance(searchCenter, a) - distance(searchCenter, b)
                );
            }*/
            let filteredProperties = propertiesArray;
            filteredProperties = propertiesArray
              .filter((property) => checkState(property, bounds))
              .sort(
                (a, b) => distance(searchCenter, a) - distance(searchCenter, b)
              );

            console.log("after", filteredProperties);

            setSearchResults(filteredProperties);
          } else setIsLoader(false);
        })
        .catch((error) => console.error(error));
    }
  }, [min, max, fetchedLatLng, isBound, searchCenter, compiledBound, searchResultBounds, searchForState]);

  const checkAdditionalConditions = (propp, bounds) => {
    let filteredData = /** @type {Property[]} */ [];

    // Filter properties by lat/long first
    if (compiledBound) {
      for (let cc = 0; cc < propp.length; cc++) {
        if (
          compiledBound.contains(
            new window.google.maps.LatLng(propp[cc].lat, propp[cc].lng)
          )
        )
          filteredData.push(propp[cc]);
      }
    } else {
      filteredData = propp;
    }

    // Then filter to properties that have any spaces that meet all three of the space-level criteria
    // If no space filters are selected, show all properties including fully-leased.
    const noSpaceFilter = !min && !max && !spaceCondition
    const meetsSFMin = (space) => {
      if (!min) return true;
      const minF = parseFloat(min); // Not sure if we really need to parseFloat. Is JS number coercion good enough?
      return space.space_available && space.space_available >= minF;
    };
    const meetsSFMax = (space) => {
      if (!max) return true;
      const maxF = parseFloat(max); // Not sure if we really need to parseFloat. Is JS number coercion good enough?
      return space.space_available && space.space_available <= maxF;
    };
    const meetsAvailability = (space) => {
      if (!spaceCondition) return true;
      const spaceConditionArr = commonSpaceCondition[spaceCondition].split(",");
      return spaceConditionArr.includes(space.space_condition);
    };

    filteredData = filteredData.filter((p) => {
      return noSpaceFilter || p.availableSpaces?.some(
        (s) => meetsSFMin(s) && meetsSFMax(s) && meetsAvailability(s),
      );
    });

    return filteredData;
  };
  useEffect(() => {
    if (searchResults && (address === "USA" || address === "United States")) {
      if (!fullRelatedProperties.length) {
        const fetchPromises2 = searchResults.map((pro) =>
          fetch("/properties/" + pro.id + ".json", { mode: "cors" }).then(
            (response) => response.json()
          )
        );

        // When all fetch requests are complete
        Promise.all(fetchPromises2)
          .then((data) => {
            setFullRelatedProperties(data);
            setRelatedProperty(checkAdditionalConditions(data));

            //setTimeout(() => {
            //  setProcessLoaded(checkAdditionalConditions(data));
            //}, 1000);
            setIsLoader(false);
            // setSearchResults(checkAdditionalConditions(data));
            //  setRelatedProperty(data);
          })
          .catch((error) => console.error(error));
      } else {
        setRelatedProperty(checkAdditionalConditions(fullRelatedProperties));

        //setTimeout(() => {
        //  setProcessLoaded(checkAdditionalConditions(fullRelatedProperties));
        //}, 1000);
        setIsLoader(false);
      }
    } else if (searchResults) {
      const fetchPromises = searchResults.map((pro) =>
        fetch("/properties/" + pro.id + ".json", { mode: "cors" }).then(
          (response) => response.json()
        )
      );
      Promise.all(fetchPromises)
        .then((data) => {
          // setFullRelatedProperties(data);
          setRelatedProperty(checkAdditionalConditions(data));

          //setTimeout(() => {
          //  setProcessLoaded(checkAdditionalConditions(data));
          //}, 1000);
          setIsLoader(false);
          // setSearchResults(checkAdditionalConditions(data));
          //  setRelatedProperty(data);
        })
        .catch((error) => console.error(error));
    }
  }, [searchResults, availability, spaceCondition, min, max]);

  // console.log(searchResults);
  return (
    <>
      {/* TODO - put Helmet here with page title and description from old search? */}
      {/* TODO - put canonical short URL here? - should this be just /search if blank and /search/city-st if a city is provided? */}
      {/*<Box pt={"91px"}>


       <Box pos={"relative"} w={"100%"}>

          <Grid
            gridTemplateColumns={{ md: "repeat(3,1fr)", base: "repeat(1,1fr)" }}
            gap={20}
          >
            <GridItem>
              <PlacesAutocomplete
                value={searchQuery}
                onChange={(value) => setSearchQuery(value)}
                onSelect={(address) => handleFormSubmit(address)}
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                }) => (
                  <div>
                    <Input
                      {...getInputProps({
                        placeholder: "Search Places ...",
                        borderRadius: "20px",
                        border: "1px solid",
                        borderColor: "DarkBlue",
                        background: "white",
                      })}
                    />
                    <div>
                      {suggestions.map((suggestion) => (
                        <div
                          {...getSuggestionItemProps(suggestion)}
                          key={suggestion.description}
                        >
                          {suggestion.description}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </PlacesAutocomplete>

              <LocateIcon
                pos={"absolute"}
                top={"50%"}
                right={"10px"}
                transform={"translateY(-50%)"}
                zIndex={1}
                cursor="pointer"
                onClick={handleLocateIconClick}
              />
            </GridItem>

            <GridItem>
              <Select
                borderRadius={"20px"}
                border={"1px solid"}
                borderColor={"DarkBlue"}
                background={"white"}
                disabled={true}
              >
                <option>Square Footage</option>
                <option>Square Footage</option>
                <option>Square Footage</option>
              </Select></GridItem>
            <GridItem>
              <Select
                borderRadius={"20px"}
                border={"1px solid"}
                borderColor={"DarkBlue"}
                background={"white"}
                disabled={true}
              >
                <option>Availability</option>
                <option>Availability</option>
                <option>Availability</option>
              </Select>
            </GridItem>
          </Grid>
        </Box>
      </Box>*/}

      <Box
        pt={"79px"}
        bgGradient="radial-gradient(36.09% 69.11% at 100% 33.15%, rgba(112, 207, 236, 0.48) 0%, rgba(116, 214, 241, 0) 100%)"
      >
        {/* <Flex pos={"relative"} display={{ lg: "none", base: "flex" }}>
          <Box pos={"relative"} w={"70%"}>
            <PlacesAutocomplete
              value={searchQuery}
              onChange={(value) => setSearchQuery(value)}
              onSelect={(address) => handleFormSubmit(address)}
            >
              {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                <div>
                  <Input
                    {...getInputProps({
                      placeholder: "Search Places ...",
                      borderRadius: "0px",
                      border: "1px solid",
                      borderColor: "DarkBlue",
                      borderRight: "0",
                      borderLeft: "0",
                      background: "white",
                    })}
                  />
                  <Box
                    sx={{
                      ".googleresult": {
                        _hover: {
                          color: "white",
                          bgColor: "BrightTurquoise",
                          cursor: "pointer",
                        },
                      },
                    }}
                  >
                    {suggestions.map((suggestion) => (
                      <Box
                        className="googleresult"
                        {...getSuggestionItemProps(suggestion)}
                        key={suggestion.description}
                      >
                        {suggestion.description}
                      </Box>
                    ))}
                  </Box>
                </div>
              )}
            </PlacesAutocomplete>
            <LocateIcon
              pos={"absolute"}
              top={"50%"}
              right={"10px"}
              transform={"translateY(-50%)"}
              zIndex={1}
              cursor="pointer"
              onClick={handleLocateIconClick}
            />
          </Box>
          <Box w={"30%"}>
            <Button
              fontWeight={"400"}
              borderRadius={"0px"}
              border={"1px solid"}
              borderColor={"DarkBlue"}
              borderRight={"0"}
              background={"white"}
              w={"100%"}
              onClick={() => setOpen(!open)}
            >
              Filter
            </Button>
            <Box
              w={"100%"}
              left={"50%"}
              transform={"translateX(-50%)"}
              border={"1px solid #ccc"}
              boxShadow={"lg"}
              display={open ? "block" : "none"}
              pos={"absolute"}
              top={"50px"}
              bgColor={"white"}
              p={4}
            >
              <Flex mb={4} gap={4} alignItems={"center"}>
                <Input
                  type="number"
                  w={"100%"}
                  placeholder="min sqft"
                  borderRadius={"20px"}
                  border={"1px solid"}
                  borderColor={"DarkBlue"}
                  background={"white"}
                />
                <Text>to</Text>
                <Input
                  type="number"
                  w={"100%"}
                  placeholder="max sqft"
                  borderRadius={"20px"}
                  border={"1px solid"}
                  borderColor={"DarkBlue"}
                  background={"white"}
                />
              </Flex>
              <Flex gap={4} alignItems={"center"}>
                <Select
                  w={"100%"}
                  borderRadius={"20px"}
                  border={"1px solid"}
                  borderColor={"DarkBlue"}
                  background={"white"}
                >
                  <option value="" selected>
                    Available By
                  </option>
                  <option value="immediately">Immediately</option>
                  <option value="30days">Within 30 days </option>
                  <option value="3months">3 months</option>
                  <option value="6months">6 months</option>
                  <option value="9months">9 months</option>
                </Select>
                <Link color={"DarkTeal"} textDecorationLine={"underline"}>
                  Reset
                </Link>
              </Flex>
            </Box>
          </Box>
        </Flex> */}
        <Grid
          mt={{ lg: 0, base: 10 }}
          bgColor={"white"}
          gridTemplateColumns={{ lg: "repeat(2, 1fr)", base: "repeat(1, 1fr)" }}
          pos={"relative"}
        >
          {!isLoader /*&& relatedProperty && relatedProperty.length > 0 */ && (
            <>
              {map ? (
                <Flex
                  flexDir={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  h={16}
                  w={16}
                  borderRadius={"full"}
                  bgColor={"DarkTeal"}
                  pos={"absolute"}
                  top={4}
                  zIndex={"10"}
                  right={2}
                  onClick={() => setMap(!map)}
                  display={{ lg: "none", base: "flex" }}
                >
                  <ListIcon w={6} h={6} />
                  <Text color={"white"} fontSize={"2xs"}>
                    List
                  </Text>
                </Flex>
              ) : (
                <Flex
                  flexDir={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  borderRadius={"full"}
                  h={16}
                  w={16}
                  bgColor={"DarkTeal"}
                  pos={"absolute"}
                  top={12}
                  zIndex={"10"}
                  right={8}
                  onClick={() => setMap(!map)}
                  display={{ lg: "none", base: "flex" }}
                >
                  <MapIcon w={6} h={6} />
                  <Text color={"white"} fontSize={"2xs"}>
                    Map
                  </Text>
                </Flex>
              )}
            </>
          )}
          {searchCenter && (
            <>
              <GridItem>
                <Box
                  pos={"relative"}
                  w={"100%"}
                  h={{ lg: "calc(100vh - 80px)", base: "calc(100vh - 120px)" }}
                  display={{ lg: "block", base: map ? "block" : "none" }}
                >
                  <SearchMap
                    center={searchCenter}
                    address={address}
                    onMapMounted={onMapMounted}
                    boundsChangedCallback={onMapBoundsChanged}
                    mapElement={<div style={{ height: `100%` }} />}
                    markers={relatedProperty}
                    markerOnClick={markerOnClick}
                  />
                </Box>
              </GridItem>
            </>
          )}

          {isLoader && (
            <GridItem>
              <Center h={"150px"} w={"100%"} display={{ lg: "block", base: map ? "none" : "block" }}>
                <Spinner thickness="4px" speed="2s" colorScheme="gray" w={"100px"} h={"100px"} />
              </Center>
            </GridItem>
          )}

          {!isLoader &&
            searchCenter &&
            // processLoaded &&
            relatedProperty &&
            !relatedProperty.length && (
              <GridItem>
                <Box
                  p={4}
                  color={"black"}
                  w={{ md: "50%", base: "calc(100% - 10px)" }}
                  bgColor={"white"}
                  boxShadow={"lg"}
                  m={"10px auto"}
                  display={{ lg: "block", base: map ? "none" : "block" }}
                >
                  No Welltower properties are visible in this map. Please search
                  again or zoom out to find out more properties
                </Box>
              </GridItem>
            )}

          {!isLoader && relatedProperty && relatedProperty.length > 0 && (
            <GridItem display={{ lg: "block", base: map ? "none" : "block" }}>
              {relatedProperty && searchCenter && (
                <Flex justifyContent={"space-between"} px={4} my={4}>
                  <Heading fontSize={"2xl"} color={"DarkTeal"}>
                    {address}
                  </Heading>
                  <Text color={"DarkBlue"}>
                    {relatedProperty.length || 0} Results
                  </Text>
                </Flex>
              )}

              <Box
                h={{ lg: "calc(100vh - 140px)", base: "calc(100vh - 183px)" }}
                px={6}
                overflow={"auto"}
                sx={{
                  "::-webkit-scrollbar": {
                    width: "6px",
                    height: "8px",
                  },

                  "::-webkit-scrollbar-track": {
                    borderRadius: "10px",
                    border: "1px solid lightgray",
                    bgColor: "lightgray",
                    height: "6px",
                  },

                  "::-webkit-scrollbar-thumb": {
                    background: "#999",
                    borderRadius: "10px",
                  },

                  "::-webkit-scrollbar-thumb:hover": {
                    background: "#bea432",
                  },
                }}
              >
                {relatedProperty && searchCenter && (
                  <Flex mb={2} gap={2} alignItems={"center"}>
                    <Image src={Pin} />
                    <Heading fontSize={"xl"}>Available</Heading>
                  </Flex>
                )}

                {relatedProperty.map((property) => (
                  <a href={propertyUrl(property)} key={propertyUrl(property)}>
                    <PropertyBox
                      property={property}
                      visitProperty={visitProperty}
                      is_available={true}
                    />
                  </a>
                ))}
                {!min && !max && !spaceCondition && (
                  <>
                    {relatedProperty && searchCenter && (
                      <Flex mb={2} gap={2} alignItems={"center"}>
                        <Image src={GrayPin} />
                        <Heading fontSize={"xl"}>Fully Leased</Heading>
                      </Flex>
                    )}

                    {relatedProperty.map((property) => (
                      <a href={propertyUrl(property)} key={propertyUrl(property)}>
                        <PropertyBox
                          property={property}
                          visitProperty={visitProperty}
                          is_available={undefined}
                        />
                      </a>
                    ))}
                  </>
                )}
              </Box>
            </GridItem>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default SearchPage;
